<template>
  <v-container class="my-results-individual">
    <result-dialog ref="resultDialog" />
    <h1 class="header-title optus-highlight optus-highlight--yellow mb-2">
      Results&nbsp;
    </h1>
    <v-row class="mb-2 mt-2" v-show="ready">
      <v-col cols="12" sm="3" class="pr-3">
        <v-select
          v-model="filterLesson"
          :items="lessons"
          item-text="name"
          item-value="id"
          :label="`Select ${this.capitalizeFirstLetter(this.lessonTerm)}`"
        />
      </v-col>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="lessonResults"
          hide-default-footer
          :options.sync="pagination"
          flat
          @page-count="pageCount = $event"
          class="background--transparent"
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.id">
                <td class="text-left">
                  {{ lesson(item.lesson_id).name }}
                </td>
                <td class="text-left">
                  {{ item.completed_at | moment('Do MMM YYYY') }}
                </td>
                <td class="text-center">{{ item.pre_quiz }}</td>
                <td class="text-center">{{ item.post_quiz }}</td>
                <td class="text-center">
                  <v-btn
                    text
                    color="primary"
                    @click="showDetailedResults(item.id)"
                  >
                    see detailed results
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
        <div v-show="pageCount > 1" class="text-center pt-2">
          <v-pagination v-model="pagination.page" :length="pageCount" />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ResultDialog from '@/modules/student/views/classes/results/ResultDialog'
import UserLesson from '@/modules/lesson/models/UserLesson'
import Lesson from '@/modules/lesson/models/Lesson'

export default {
  name: 'Results',
  components: {
    ResultDialog
  },
  data() {
    return {
      pagination: {
        sortBy: ['completed_at'],
        sortDesc: [true],
        itemsPerPage: 15
      },
      pageCount: 0,
      headers: [
        { text: 'Name', align: 'left', value: 'lesson_id' },
        { text: 'Completed Date', value: 'completed_at' },
        { text: 'Pre Quiz', value: 'pre_quiz' },
        { text: 'Post Quiz', value: 'post_quiz' },
        { text: '', value: '' }
      ],
      filterLesson: '',
      lessons: [
        {
          name: '-- All --',
          id: ''
        }
      ],
      ready: false
    }
  },
  async mounted() {
    this.$store.state.loading = true
    await Lesson.dispatch('fetch', this.$route.meta.type)
    await UserLesson.dispatch('fetchAll', 'individuals')
    this.lessons = this.lessons.concat(Lesson.all())
    setTimeout(() => {
      this.ready = true
      this.$store.state.loading = false
    })
  },
  computed: {
    ...mapState(['lessonTerm']),
    ...mapGetters('entities/classes', ['currentClassId']),
    lessonResults() {
      let userLessons = UserLesson.query().where(
        'custom_class_id',
        this.currentClassId
      )

      userLessons.where('is_completed', true)

      if (this.filterLesson) {
        userLessons.where('lesson_id', this.filterLesson)
      }
      return userLessons.get()
    },
    lesson() {
      return id => Lesson.find(id)
    }
  },
  methods: {
    showDetailedResults(id) {
      this.$refs.resultDialog.show(id)
    }
  }
}
</script>

<style lang="scss">
.my-results-individual {
  box-shadow: none;

  .background--transparent {
    table.v-table {
      background: transparent;
    }
  }
}
</style>
